<template>
  <div class="container-base" v-once>
    <div class="pages page-static law">
      <div class="page-static-inner">

        <h1>特定商取引法に基づく表示</h1>

        <h2>1.事業者の名称</h2>
        <p>株式会社Yagish</p>

        <h2>2.代表</h2>
        <p>代表取締役社長　金 相集(キム サンジプ)</p>

        <h2>3.所在地</h2>
        <p>〒150-0011　東京都渋谷区東一丁目12番2号</p>

        <h2>4.電話番号</h2>
        <p>お電話でのお問い合わせは、承っておりません。<br>お問い合わせフォームよりお問い合わせ下さい。</p>

        <h2>5.URL</h2>
        <p>https://rirekisho.yagish.jp</p>

        <h2>6.販売価格</h2>
        <p>各サービスのご購入ページに表示する価格</p>

        <h2>7.対価以外に必要となる費用</h2>
        <p>インターネット接続をするための機器、インターネット接続料金、通信料金、その他サービスを利用するために必要となる費用</p>

        <h2>8.支払い方法</h2>
        <p>クレジットカード（VISA/MasterCard/JCB/AMEX/DINERS）<br>PayPay</p>

        <h2>9.支払時期</h2>
        <p>料金はご購入・申込み時に課金決済いたします。<br>支払い時期はカード会社の会員規約で定められた振替日により異なります。</p>

        <h2>10.商品の引渡し時期</h2>
        <p>ヤギのメール便は課金処理後、応募先にメールで送られます。<br>ヤギプライムは決済後すぐにご利用可能です。</p>

        <h2>11.返品・返金・キャンセル</h2>
        <p>
          商品の性質上、購入後のキャンセル、返品、返金はできないものとします。<br>
          会員の利用環境に起因して商品がお使いいただけないことを理由に返品・返金はできないものとします。<br>
          （例：対応ソフトがない、OSが非対応、スマートフォンから使えない、など）
        </p>

        <div class="back-button">
          <router-link to="/">トップに戻る</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>

<style lang="scss" scoped>
.law {

  .page-static-inner {
    padding-top: 50px;

    &:first-child {
      padding-top: 0;
    }
  }

  h1 {
    font-size: 20px;
  }

  h2 {
    padding-top: 15px;
    margin-bottom: 10px;
    text-align: left;
    font-size: 18px;
  }

  //数字リスト
  .decimal {
    list-style-type: decimal;
  }

  //・リスト
  .disc {
    list-style-type: disc;
  }

  .underline {
    border-bottom: 1px solid rgb(64, 64, 64);

    li {
      border-bottom: 1px solid rgb(64, 64, 64);

      &:last-child {
        border: none;
      }
    }
  }

  .last-p{
    margin-top: 1rem;
  }
}
</style>
<script>
export default {
  data: function () {
    return {}
  },
  computed: {},
  methods: {},
  watch: {},
  mounted: function () { }
}
</script>
